import SIGMA_EXT_1 from "./SIGMA_EXT_1";
export default {
  SIGMA_EXT_1,
};
